<p-carousel [numVisible]="numVisibleItems"
            [circular]="circular"
            [value]="photos">
    <ng-template let-photo pTemplate="item">
        <div class="carousel-item">
            <img *ngIf="photo.url" [src]='getSanitizedUrl(photo.url)' (click)="showPhoto($event, photo)">
            <app-icon library="fontawesome"
                      variant="fa-minus"
                      *ngIf="canDelete"
                      type="danger"
                      class="close-button"
                      (click)="removePhoto($event, photo)">
            </app-icon>
        </div>
    </ng-template>
</p-carousel>


<app-modal class="modal" (click)="closeModal()">
    <ng-container modal-header>
        <h5 class="modal-title">
            {{ 'admin.plants.create-modal.title' | translate }}</h5>
    </ng-container>
    <ng-container modal-body>
        <img [src]='getSanitizedUrl(selectedPhoto.url)' *ngIf="selectedPhoto?.url">
    </ng-container>
</app-modal>
